var isType = require('./is-type');

var isString = function isString(str) {
  return isType(str, 'String');
};

module.exports = isString;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/type/is-string.js
// module id = 4
// module chunks = 0